exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".callout-panel {\n  font-size: 0.9rem;\n  margin: 30px 0;\n  text-align: center; }\n\n.callout-panel p {\n  margin: 2px 0; }\n\n.callout-panel-icon {\n  border-radius: 50%;\n  color: #fff;\n  width: 80px;\n  height: 80px;\n  margin-bottom: 20px; }\n\n.callout-panel-icon i {\n  font-size: 60px;\n  margin-top: 10px; }\n\n.callout-message {\n  margin-bottom: 40px; }\n\n.delete-alert {\n  background: #FB8C00; }\n\n.alert-item-details {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 15px 0; }\n\n.lowercase {\n  text-transform: lowercase; }\n\nbutton {\n  margin: 0 1px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/alert-overview/components/delete-alert/delete-alert.component.scss
// module id = 1313
// module chunks = 0